<template>
  <div class="publicMain">
    <el-row>
      <!-- 树形菜单 -->
      <el-col :span="4" style="padding-right: 10px;">
        <!-- <el-card class="box-card" style="text-align: left;"> -->
        <el-row style="text-align: left">
          <span style="font-weight: bold;">{{ $t("ympz.qxzym") }}</span>
          <el-divider style="margin: 2px 0;"></el-divider>
        </el-row>
        <el-row>
          <el-tree
            :data="treeData"
            ref="pageTree"
            node-key="qid"
            highlight-current
            :props="treeDefaultProps"
            :expand-on-click-node="false"
            accordion
            key="qid"
            @node-click="handleNodeClick"
            :default-expanded-keys="['X']"
          >
          </el-tree>
        </el-row>
        <!-- </el-card> -->
      </el-col>
      <el-col :span="20" style="text-align: left">
        <el-row style="font-weight: bold; font-size: 15px;">
          {{ $t("ympz.cxqy") }}
        </el-row>
        <el-row>
          <el-table
            :data="queryAreaData"
            border
            style="width: 100%; font-size: 12px;"
            ref="queryAreaMultiple"
            :cellStyle="$store.state.cellStyle"
            :headerCellStyle="$store.state.headerCellStyle"
            v-loading="queryAreaLoading"
            :element-loading-text="$t('elTable.loadingText')"
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column
              prop="pageId"
              :label="$t('ympz.ymbs')"
              align="center"
              fixed
            ></el-table-column>
            <el-table-column
              prop="moduleId"
              :label="$t('ympz.mkbs')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="groupId"
              :label="$t('ympz.zbs')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="fieldId"
              :label="$t('ympz.zdbs')"
              align="center"
            ></el-table-column>
            <el-table-column :label="$t('ympz.sfxs')" align="center">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.isShow == '1'"
                  size="small"
                  type="success"
                  >{{ $t("common.yes") }}</el-tag
                >
                <el-tag v-else size="small" type="danger">{{
                  $t("common.no")
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              :prop="'componentTiltle[' + $i18n.locale + ']'"
              :label="$t('ympz.zujbt')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="componentSize"
              :label="$t('ympz.zjcc')"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('common.operation')"
              width="100px"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="openDialog('queryAreaEdit', scope.row)"
                >
                  <i class="el-icon-edit"></i>
                  <span>{{ $t("common.editBtn") }}</span>
                </el-button>
                <!-- <el-button type="text" @click="openDialog('queryAreaDel', [scope.row])">{{ $t('common.deleteBtn') }}</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row>
          <!-- 分页组件 -->
          <Pagination
            :currentPage="queryAreaCurrentPage"
            :total="queryAreaTotal"
            :limit="queryAreaLimit"
            :small="true"
            :pageSizes="$store.state.pageSizes"
            @handleCurrentChange="queryAreaHandleCurrentChange"
            @handleSizeChange="queryAreaHandleSizeChange"
          />
        </el-row>
        <el-row style="font-weight: bold; font-size: 15px;">
          {{ $t("ympz.bgxx") }}
        </el-row>
        <el-row>
          <el-table
            :data="tableAreaData"
            border
            style="width: 100%; font-size: 12px;"
            :default-expand-all="false"
            ref="tableAreaMultiple"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            :row-key="getRowKeys"
            :cellStyle="$store.state.cellStyle"
            :headerCellStyle="$store.state.headerCellStyle"
            v-loading="tableAreaLoading"
            :element-loading-text="$t('elTable.loadingText')"
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column
              prop="pageId"
              :label="$t('ympz.ymbs')"
              align="center"
              fixed
            ></el-table-column>
            <el-table-column
              prop="moduleId"
              :label="$t('ympz.mkbs')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="groupId"
              :label="$t('ympz.zbs')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="fieldId"
              :label="$t('ympz.zdbs')"
              align="center"
            ></el-table-column>
            <el-table-column
              :prop="'fieldName[' + $i18n.locale + ']'"
              :label="$t('ympz.zdm')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="headerAlign"
              :label="$t('ympz.btdqfs')"
              align="center"
            ></el-table-column>
            <!-- <el-table-column
              prop="columnAlign"
              label="字段对齐方式"
              align="center"
            ></el-table-column> -->
            <!-- <el-table-column label="是否可选列" align="center">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.isSelectedDisable == '1'"
                  size="small"
                  type="success"
                  >{{ $t("common.yes") }}</el-tag
                >
                <el-tag v-else size="small" type="danger">{{
                  $t("common.no")
                }}</el-tag>
              </template>
            </el-table-column> -->
            <el-table-column :label="$t('ympz.sfxs')" align="center">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.isShow == '1'"
                  size="small"
                  type="success"
                  >{{ $t("common.yes") }}</el-tag
                >
                <el-tag v-else size="small" type="danger">{{
                  $t("common.no")
                }}</el-tag>
              </template>
            </el-table-column>
            <!-- <el-table-column label="是否链接" align="center">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.isLink == '1'"
                  size="small"
                  type="success"
                  >{{ $t("common.yes") }}</el-tag
                >
                <el-tag v-else size="small" type="danger">{{
                  $t("common.no")
                }}</el-tag>
              </template>
            </el-table-column> -->
            <el-table-column :label="$t('ympz.sfan')" align="center">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.isButton == '1'"
                  size="small"
                  type="success"
                  >{{ $t("common.yes") }}</el-tag
                >
                <el-tag v-else size="small" type="danger">{{
                  $t("common.no")
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ympz.sfje')" align="center">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.isAmountOfMoney == '1'"
                  size="small"
                  type="success"
                  >{{ $t("common.yes") }}</el-tag
                >
                <el-tag v-else size="small" type="danger">{{
                  $t("common.no")
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('common.operation')"
              width="100px"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="openDialog('tableAreaEdit', scope.row)"
                >
                  <i class="el-icon-edit"></i>
                  <span>{{ $t("common.editBtn") }}</span>
                </el-button>
                <!-- <el-button type="text" @click="openDialog('tableAreaDel', [scope.row])">{{ $t('common.deleteBtn') }}</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row>
          <!-- 分页组件 -->
          <Pagination
            :currentPage="tableAreaCurrentPage"
            :total="tableAreaTotal"
            :limit="tableAreaLimit"
            :small="true"
            :pageSizes="$store.state.pageSizes"
            @handleCurrentChange="tableAreaHandleCurrentChange"
            @handleSizeChange="tableAreaHandleSizeChange"
          />
        </el-row>
      </el-col>
    </el-row>

    <!-- 查询区域模态框 -->
    <el-dialog
      :title="queryAreaDialogTitle"
      :visible.sync="queryAreaVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @close="handleClose('queryArea')"
    >
      <label slot="title">
        <i
          :class="queryAreaDialogTitleIcon"
          style="font-size: 16px; font-weight: bold;"
        >
          <span style="margin-right: 5px;">
            {{ this.queryAreaDialogTitle }}
          </span>
        </i>
      </label>
      <el-card style="padding: 0 5%">
        <el-form
          :model="queryAreaRuleForm"
          :rules="queryAreaRules"
          ref="queryAreaRuleForm"
          label-width="140px"
          :validate-on-rule-change="false"
          size="small"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('ympz.ymbs')" prop="pageId">
                <el-input
                  v-model="queryAreaRuleForm.pageId"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('ympz.mkbs')" prop="moduleId">
                <el-input
                  v-model="queryAreaRuleForm.moduleId"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('ympz.zbs')" prop="groupId">
                <el-input
                  v-model="queryAreaRuleForm.groupId"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('ympz.zdbs')" prop="fieldId">
                <el-input
                  v-model="queryAreaRuleForm.fieldId"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('ympz.zujbtzw')"
                prop="componentTiltleZh"
              >
                <el-input
                  v-model="queryAreaRuleForm.componentTiltleZh"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('ympz.zujbtyw')"
                prop="componentTiltleEn"
              >
                <el-input
                  v-model="queryAreaRuleForm.componentTiltleEn"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('ympz.zwwbzw')" prop="placeholderTextZh">
                <el-input
                  v-model="queryAreaRuleForm.placeholderTextZh"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('ympz.zwwbyw')" prop="placeholderTextEn">
                <el-input
                  v-model="queryAreaRuleForm.placeholderTextEn"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('ympz.zjcc')" prop="componentSize">
                <el-input v-model="queryAreaRuleForm.componentSize"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('ympz.sfxs')" prop="isShow">
                <el-switch
                  class="isShowClass"
                  v-model="queryAreaRuleForm.isShow"
                  active-value="1"
                  inactive-value="0"
                  :active-text="$t('common.yes')"
                  :inactive-text="$t('common.no')"
                >
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item
              :label="$t('ympz.bz')"
              prop="remarks"
              style="margin-bottom: 0px;"
            >
              <el-input
                type="textarea"
                v-model="queryAreaRuleForm.remarks"
                maxlength="300"
                show-word-limit
                :autosize="{ minRows: 3, maxRows: 6 }"
              ></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click="queryAreaVisible = false" size="small">{{
          $t("common.cancelBtn")
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitForm('queryAreaRuleForm')"
          >{{ $t("common.saveBtn") }}</el-button
        >
      </div>
    </el-dialog>

    <!-- 表格区域模态框 -->
    <el-dialog
      :title="tableAreaDialogTitle"
      :visible.sync="tableAreaVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @close="handleClose('tableArea')"
      top="10vh"
    >
      <label slot="title">
        <i
          :class="tableAreaDialogTitleIcon"
          style="font-size: 16px; font-weight: bold;"
        >
          <span style="margin-right: 5px;">
            {{ this.tableAreaDialogTitle }}
          </span>
        </i>
      </label>
      <el-card>
        <el-form
          :model="tableAreaRuleForm"
          :rules="tableAreaRules"
          ref="tableAreaRuleForm"
          label-width="120px"
          :validate-on-rule-change="false"
          size="small"
        >
          <el-row>
            <el-col :span="24">
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.ymbs')" prop="pageId">
                    <el-input
                      v-model="tableAreaRuleForm.pageId"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.mkbs')" prop="moduleId">
                    <el-input
                      v-model="tableAreaRuleForm.moduleId"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.zbs')" prop="groupId">
                    <el-input
                      v-model="tableAreaRuleForm.groupId"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.zdbs')" prop="fieldId">
                    <el-input
                      v-model="tableAreaRuleForm.fieldId"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.zwmc')" prop="chinese">
                    <el-input v-model="tableAreaRuleForm.chinese"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.zwzdkd')" prop="cnColumnWidth">
                    <el-input
                      v-model="tableAreaRuleForm.cnColumnWidth"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.sfkbj')" prop="isEdit">
                    <el-switch
                      class="isShowClass"
                      v-model="tableAreaRuleForm.isEdit"
                      active-value="1"
                      inactive-value="0"
                      :active-text="$t('common.yes')"
                      :inactive-text="$t('common.no')"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.ywmc')" prop="english">
                    <el-input v-model="tableAreaRuleForm.english"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.ywzdkd')" prop="enColumnWidth">
                    <el-input
                      v-model="tableAreaRuleForm.enColumnWidth"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.gdwz')" prop="fixedColumn">
                    <el-select
                      v-model="tableAreaRuleForm.fixedColumn"
                      :placeholder="$t('ympz.gdwz')"
                      clearable
                      size="small"
                      class="wt-all"
                    >
                      <el-option
                        v-for="item in positionOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.btdqfs')" prop="headerAlign">
                    <!-- <el-input v-model="tableAreaRuleForm.headerAlign"></el-input> -->
                    <el-select
                      v-model="tableAreaRuleForm.headerAlign"
                      :placeholder="$t('ympz.btdqfs')"
                      clearable
                      size="small"
                    >
                      <el-option
                        v-for="item in alignOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.zddqfs')" prop="columnAlign">
                    <el-select
                      v-model="tableAreaRuleForm.columnAlign"
                      :placeholder="$t('ympz.zddqfs')"
                      clearable
                      size="small"
                    >
                      <el-option
                        v-for="item in alignOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.sfxs')" prop="isShow">
                    <el-switch
                      class="isShowClass"
                      v-model="tableAreaRuleForm.isShow"
                      active-value="1"
                      inactive-value="0"
                      :active-text="$t('common.yes')"
                      :inactive-text="$t('common.no')"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.sflj')" prop="isLink">
                    <el-switch
                      class="isShowClass"
                      v-model="tableAreaRuleForm.isLink"
                      active-value="1"
                      inactive-value="0"
                      :active-text="$t('common.yes')"
                      :inactive-text="$t('common.no')"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.ljwb')" prop="linkText">
                    <el-input
                      v-model="tableAreaRuleForm.linkText"
                      :disabled="tableAreaRuleForm.isLink == '0'"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.sfan')" prop="isButton">
                    <el-switch
                      class="isShowClass"
                      v-model="tableAreaRuleForm.isButton"
                      active-value="1"
                      inactive-value="0"
                      :active-text="$t('common.yes')"
                      :inactive-text="$t('common.no')"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.anwb')" prop="buttonText">
                    <el-input
                      v-model="tableAreaRuleForm.buttonText"
                      :disabled="tableAreaRuleForm.isButton == '0'"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.ancc')" prop="buttonSize">
                    <el-select
                      v-model="tableAreaRuleForm.buttonSize"
                      :disabled="tableAreaRuleForm.isButton == '0'"
                      :placeholder="$t('ympz.ancc')"
                      clearable
                      size="small"
                    >
                      <el-option
                        v-for="item in btnSizeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('ympz.sfqygl')"
                    prop="isEnableFilter"
                  >
                    <el-switch
                      class="isShowClass"
                      v-model="tableAreaRuleForm.isEnableFilter"
                      active-value="1"
                      inactive-value="0"
                      :active-text="$t('common.yes')"
                      :inactive-text="$t('common.no')"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('ympz.sfkcl')"
                    prop="isSelectedDisable"
                  >
                    <el-switch
                      class="isShowClass"
                      v-model="tableAreaRuleForm.isSelectedDisable"
                      active-value="1"
                      inactive-value="0"
                      :active-text="$t('common.yes')"
                      :inactive-text="$t('common.no')"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.sfje')" prop="isAmountOfMoney">
                    <el-switch
                      class="isShowClass"
                      v-model="tableAreaRuleForm.isAmountOfMoney"
                      active-value="1"
                      inactive-value="0"
                      :active-text="$t('common.yes')"
                      :inactive-text="$t('common.no')"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('ympz.djsjclmc')"
                    prop="clickHandlerName"
                  >
                    <el-input
                      v-model="tableAreaRuleForm.clickHandlerName"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.djsjclq')" prop="clickHandler">
                    <el-input
                      v-model="tableAreaRuleForm.clickHandler"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.ldwybz')" prop="columnKey">
                    <el-input v-model="tableAreaRuleForm.columnKey"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.cjl')" prop="childColumns">
                    <el-input
                      v-model="tableAreaRuleForm.childColumns"
                      :disabled="childFlg"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.fjbt')" prop="pid">
                    <el-input
                      v-model="tableAreaRuleForm.pid"
                      :disabled="pqidFlg"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.zijbt')" prop="qid">
                    <el-input
                      v-model="tableAreaRuleForm.qid"
                      :disabled="pqidFlg"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('ympz.xh')" prop="sortNum">
                    <el-input v-model="tableAreaRuleForm.sortNum"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ympz.ccyc')" prop="showTooltip">
                    <el-switch
                      class="isShowClass"
                      v-model="tableAreaRuleForm.showTooltip"
                      active-value="1"
                      inactive-value="0"
                      :active-text="$t('common.yes')"
                      :inactive-text="$t('common.no')"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item
                    :label="$t('ympz.bz')"
                    prop="remarks"
                    style="margin-bottom: 0px;"
                  >
                    <el-input
                      type="textarea"
                      v-model="tableAreaRuleForm.remarks"
                      maxlength="300"
                      show-word-limit
                      :autosize="{ minRows: 4, maxRows: 7 }"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tableAreaVisible = false" size="small">{{
          $t("common.cancelBtn")
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitForm('tableAreaRuleForm')"
          >{{ $t("common.saveBtn") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as xtsz from "@/api/xtsz";
export default {
  name: "ympz",
  computed: {
    childFlg() {
      if (
        this.$comUtils.isEmpty(this.tableAreaRuleForm.childColumns) &&
        this.$comUtils.isEmpty(this.tableAreaRuleForm.pid) &&
        this.$comUtils.isEmpty(this.tableAreaRuleForm.qid)
      ) {
        return false;
      } else if (!this.$comUtils.isEmpty(this.tableAreaRuleForm.childColumns)) {
        this.tableAreaRuleForm.pid = "";
        this.tableAreaRuleForm.qid = "";
        return false;
      } else if (
        !this.$comUtils.isEmpty(this.tableAreaRuleForm.pid) ||
        !this.$comUtils.isEmpty(this.tableAreaRuleForm.qid)
      ) {
        this.tableAreaRuleForm.childColumns = "";
        return true;
      }
    },
    pqidFlg() {
      if (
        this.$comUtils.isEmpty(this.tableAreaRuleForm.childColumns) &&
        this.$comUtils.isEmpty(this.tableAreaRuleForm.pid) &&
        this.$comUtils.isEmpty(this.tableAreaRuleForm.qid)
      ) {
        return false;
      } else if (!this.$comUtils.isEmpty(this.tableAreaRuleForm.childColumns)) {
        this.tableAreaRuleForm.pid = "";
        this.tableAreaRuleForm.qid = "";
        return true;
      } else if (
        !this.$comUtils.isEmpty(this.tableAreaRuleForm.pid) ||
        !this.$comUtils.isEmpty(this.tableAreaRuleForm.qid)
      ) {
        this.tableAreaRuleForm.childColumns = "";
        return false;
      }
    },
    treeDefaultProps() {
      // 默认权限数据节点绑定数据
      return {
        // label: 'fieldName'[this.$i18n.locale],
        label: this.$i18n.locale == "zh" ? "qname" : "qname",
        children: "children",
      };
    },
    queryAreaRules() {
      // 查询区域模态框数据校验规则
      return {
        pageId: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        moduleId: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        groupId: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        fieldId: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        componentTiltleZh: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        componentTiltleEn: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
      };
    },
    tableAreaRules() {
      // 表格区域模态框数据校验规则
      return {
        pageId: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        moduleId: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        groupId: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        fieldId: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        chinese: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        cnColumnWidth: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        english: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        enColumnWidth: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        headerAlign: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "change",
          },
        ],
        columnAlign: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "change",
          },
        ],
        columnKey: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
        sortNum: [
          {
            required: true,
            message: this.$t("mbxq.ruleMsg") + "",
            trigger: "blur",
          },
        ],
      };
    },
  },
  data() {
    return {
      treeData: [], // 页面配置树
      positionOptions: [
        {
          value: "left",
          label: "left",
        },
        {
          value: "right",
          label: "right",
        },
      ],
      alignOptions: [
        {
          value: "left",
          label: "left",
        },
        {
          value: "center",
          label: "center",
        },
        {
          value: "right",
          label: "right",
        },
      ],
      btnSizeOptions: [
        {
          value: "medium",
          label: "medium",
        },
        {
          value: "small",
          label: "small",
        },
        {
          value: "mini",
          label: "mini",
        },
      ],
      queryForm: {
        // 查询条件
        pageId: "Y",
      },
      saveFlg: "", // 保存操作区分

      queryAreaRuleForm: {
        beforeUserId: "",
        beforePageId: "",
        beforeModuleId: "",
        beforeGroupId: "",
        beforeFieldId: "",
        pageId: "",
        moduleId: "",
        groupId: "",
        fieldId: "",
        componentTiltleZh: "",
        componentTiltleEn: "",
        placeholderTextZh: "",
        placeholderTextEn: "",
        componentSize: "",
        isShow: "1",
        remarks: "",
      },
      queryAreaLoading: false, // 查询数据loading层
      queryAreaVisible: false, // 查询区域模态框显隐
      queryAreaDialogTitle: "", // 查询区域模态框标题
      queryAreaDialogTitleIcon: "", // 查询区域模态框标题图标
      queryAreaData: [], // 查询区域数据
      queryAreaMultiple: [], // 查询区域选择列
      queryAreaEditDisabled: true, // 查询区域编辑按钮状态
      queryAreaDelDisabled: true, // 查询区域删除按钮状态
      queryAreaCurrentPage: 1, // 查询区域页码
      queryAreaLimit: this.$store.state.dataDisplayNum, // 查询区域分页显示条数
      queryAreaTotal: 0, // 查询区域列表数据量
      queryAreaPageSizes: this.$store.state.pageSizes, // 查询区域分页显示可选择条数

      tableAreaRuleForm: {
        beforeUserId: "",
        beforePageId: "",
        beforeModuleId: "",
        beforeGroupId: "",
        beforeFieldId: "",
        pageId: "",
        moduleId: "",
        groupId: "",
        fieldId: "",
        chinese: "",
        cnColumnWidth: "",
        english: "",
        enColumnWidth: "",
        isEdit: "0",
        fixedColumn: "",
        headerAlign: "",
        columnAlign: "",
        isShow: "1",
        isLink: "0",
        linkText: "",
        isButton: "0",
        buttonText: "",
        buttonSize: "",
        isEnableFilter: "0",
        isSelectedDisable: "1",
        isAmountOfMoney: "0",
        clickHandlerName: "",
        columnKey: "",
        childColumns: "",
        clickHandler: "",
        pid: "",
        qid: "",
        remarks: "",
        sortNum: "",
        showTooltip: "",
      },
      tableAreaLoading: false, // 表格区域loading层
      tableAreaVisible: false, // 表格区域模态框显隐
      tableAreaDialogTitle: "", // 表格区域模态框标题
      tableAreaDialogTitleIcon: "", // 表格区域模态框标题图标
      tableAreaData: [], // 表格区域数据
      tableAreaMultiple: [], // 表格区域选择列
      tableAreaEditDisabled: true, // 表格区域编辑按钮状态
      tableAreaDelDisabled: true, // 表格区域删除按钮状态
      tableAreaCurrentPage: 1, // 表格区域页码
      tableAreaLimit: this.$store.state.dataDisplayNum, // 表格区域分页显示条数
      tableAreaTotal: 0, // 表格区域列表数据量
      tableAreaPageSizes: this.$store.state.pageSizes, // 表格区域分页显示可选择条数
    };
  },
  methods: {
    // 获取页面菜单
    getPageMenu() {
      let _this = this;
      _this.treeData = [];
      xtsz.getYmszTree({}).then((res) => {
        if (res.data.code == "200") {
          _this.treeData = res.data.data;
        }
      });
    },
    /** 节点被点击时的回调 */
    handleNodeClick(data) {
      this.queryForm.pageId = data.qid;
      this.queryAreaCurrentPage = 1;
      this.tableAreaCurrentPage = 1;
      this.getQueryAreaConfig();
      this.getTableAreaConfig();
    },
    openDialog(flg, row) {
      if (flg == "queryAreaEdit") {
        this.queryAreaVisible = true;
        this.$nextTick(() => {
          this.queryAreaDialogTitle = this.$t("common.editBtn");
          this.queryAreaDialogTitleIcon = "el-icon-edit-outline";
          this.queryAreaRuleForm.beforePageId = row.pageId;
          this.queryAreaRuleForm.beforeModuleId = row.moduleId;
          this.queryAreaRuleForm.beforeGroupId = row.groupId;
          this.queryAreaRuleForm.beforeFieldId = row.fieldId;
          this.queryAreaRuleForm.pageId = row.pageId;
          this.queryAreaRuleForm.moduleId = row.moduleId;
          this.queryAreaRuleForm.groupId = row.groupId;
          this.queryAreaRuleForm.fieldId = row.fieldId;
          this.queryAreaRuleForm.componentTiltleZh = row.componentTiltleZh;
          this.queryAreaRuleForm.componentTiltleEn = row.componentTiltleEn;
          this.queryAreaRuleForm.placeholderTextZh = row.placeholderTextZh;
          this.queryAreaRuleForm.placeholderTextEn = row.placeholderTextEn;
          this.queryAreaRuleForm.componentSize = row.componentSize;
          this.queryAreaRuleForm.isShow = row.isShow;
          this.queryAreaRuleForm.remarks = row.remarks;
        });
      } else if (flg == "tableAreaEdit") {
        this.tableAreaVisible = true;
        this.$nextTick(() => {
          this.tableAreaDialogTitle = this.$t("common.editBtn");
          this.tableAreaDialogTitleIcon = "el-icon-edit-outline";
          this.tableAreaRuleForm.beforePageId = row.pageId;
          this.tableAreaRuleForm.beforeModuleId = row.moduleId;
          this.tableAreaRuleForm.beforeGroupId = row.groupId;
          this.tableAreaRuleForm.beforeFieldId = row.fieldId;
          this.tableAreaRuleForm.pageId = row.pageId;
          this.tableAreaRuleForm.moduleId = row.moduleId;
          this.tableAreaRuleForm.groupId = row.groupId;
          this.tableAreaRuleForm.fieldId = row.fieldId;
          this.tableAreaRuleForm.chinese = row.chinese;
          this.tableAreaRuleForm.cnColumnWidth = row.cnColumnWidth;
          this.tableAreaRuleForm.english = row.english;
          this.tableAreaRuleForm.enColumnWidth = row.enColumnWidth;
          this.tableAreaRuleForm.isEdit = row.isEdit;
          this.tableAreaRuleForm.fixedColumn = row.fixedColumn;
          this.tableAreaRuleForm.headerAlign = row.headerAlign;
          this.tableAreaRuleForm.columnAlign = row.columnAlign;
          this.tableAreaRuleForm.isShow = row.isShow;
          this.tableAreaRuleForm.isLink = row.isLink;
          this.tableAreaRuleForm.linkText = row.linkText;
          this.tableAreaRuleForm.isButton = row.isButton;
          this.tableAreaRuleForm.buttonText = row.buttonText;
          this.tableAreaRuleForm.buttonSize = row.buttonSize;
          this.tableAreaRuleForm.isEnableFilter = row.isEnableFilter;
          this.tableAreaRuleForm.isSelectedDisable = row.isSelectedDisable;
          this.tableAreaRuleForm.isAmountOfMoney = row.isAmountOfMoney;
          this.tableAreaRuleForm.clickHandlerName = row.clickHandlerName;
          this.tableAreaRuleForm.columnKey = row.columnKey;
          this.tableAreaRuleForm.childColumns = row.childColumns;
          this.tableAreaRuleForm.clickHandler = row.clickHandler;
          this.tableAreaRuleForm.pid = row.pid;
          this.tableAreaRuleForm.qid = row.qid;
          this.tableAreaRuleForm.remarks = row.remarks;
          this.tableAreaRuleForm.sortNum = row.sortNum;
          this.tableAreaRuleForm.showTooltip = row.showTooltip;
        });
      }
      this.saveFlg = flg;
    },
    /** 保存查询区域模态框数据 */
    submitForm(formName) {
      if (this.saveFlg === "tableAreaEdit") {
        if (
          (!this.$comUtils.isEmpty(this.tableAreaRuleForm.pid) &&
            this.$comUtils.isEmpty(this.tableAreaRuleForm.qid)) ||
          (this.$comUtils.isEmpty(this.tableAreaRuleForm.pid) &&
            !this.$comUtils.isEmpty(this.tableAreaRuleForm.qid))
        ) {
          this.$message.error("父级表头和自己表头必须同时为空或不为空");
          return false;
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.saveFlg === "queryAreaEdit") {
            this.editQueryArea();
          } else if (this.saveFlg === "tableAreaEdit") {
            this.editTableArea();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /** 编辑查询区域条件 */
    editQueryArea() {
      let _this = this;
      xtsz
        .editQueryArea(_this.queryAreaRuleForm)
        .then((res) => {
          _this.queryAreaVisible = false;
          let msgCode = res.status;
          if (res.status == "200") {
            if (res.data.code == "200") {
              _this.$message.success(_this.$t("common.editSuccess"));
              _this.getQueryAreaConfig();
            }
          }
        })
        .catch((error) => {
          _this.queryAreaVisible = false;
        });
    },
    /** 编辑表格区域条件 */
    editTableArea() {
      let _this = this;
      xtsz
        .editTableArea(_this.tableAreaRuleForm)
        .then((res) => {
          _this.tableAreaVisible = false;
          let msgCode = res.status;
          if (res.status == "200") {
            if (res.data.code == "200") {
              _this.$message.success(_this.$t("common.editSuccess"));
              _this.getTableAreaConfig();
            }
          }
        })
        .catch((error) => {
          _this.tableAreaVisible = false;
        });
    },
    /** 获取页面查询区域配置 */
    getQueryAreaConfig() {
      let _this = this;
      _this.queryAreaData = [];
      _this.queryForm.queryAreaCurrentPage = _this.queryAreaCurrentPage;
      _this.queryForm.queryAreaLimit = _this.queryAreaLimit;
      _this.queryAreaLoading = true; // 关闭请求时的loading层
      xtsz
        .getQueryAreaConfig(_this.queryForm)
        .then((res) => {
          _this.queryAreaLoading = false; // 关闭请求时的loading层
          let msgCode = res.status;
          if (res.status == "200") {
            if (res.data.code == "200") {
              if (res.data.data.length > 0) {
                _this.queryAreaTotal = parseInt(
                  res.data.data[0].queryAreaTableCount
                );
              } else {
                _this.queryAreaTotal = 0;
              }
              _this.queryAreaData = res.data.data;
            }
          }
        })
        .catch((error) => {
          _this.queryAreaLoading = false; // 关闭请求时的loading层
        });
    },
    /** 获取页面表格区域配置 */
    getTableAreaConfig() {
      let _this = this;
      _this.tableAreaData = [];
      _this.queryForm.tableAreaCurrentPage = _this.tableAreaCurrentPage;
      _this.queryForm.tableAreaLimit = _this.tableAreaLimit;
      _this.tableAreaLoading = true; // 关闭请求时的loading层
      xtsz
        .getTableAreaConfig(_this.queryForm)
        .then((res) => {
          _this.tableAreaLoading = false; // 关闭请求时的loading层
          let msgCode = res.status;
          if (res.status == "200") {
            if (res.data.code == "200") {
              if (res.data.data.length > 0) {
                _this.tableAreaTotal = parseInt(
                  res.data.data[0].tableAreaTableCount
                );
              } else {
                _this.tableAreaTotal = 0;
              }
              _this.tableAreaData = res.data.data;
            }
          }
        })
        .catch((error) => {
          _this.tableAreaLoading = false; // 关闭请求时的loading层
        });
    },
    getRowKeys(row) {
      return row.pageId + row.moduleId + row.groupId + row.fieldId;
      // return Math.random();
    },
    handleClose(flg) {
      if (flg == "queryArea") {
        this.$refs["queryAreaRuleForm"].resetFields();
      } else if (flg == "tableArea") {
        this.$refs["tableAreaRuleForm"].resetFields();
      }
    },
    /** 查询区域页码改变时会触发 */
    queryAreaHandleCurrentChange(uniqueNum, val) {
      this.queryAreaCurrentPage = val;
      this.getQueryAreaConfig();
    },
    /** 查询区域每页条数改变时触发 */
    queryAreaHandleSizeChange(uniqueNum, val) {
      this.queryAreaLimit = val;
      this.queryAreaCurrentPage = 1;
      this.getQueryAreaConfig();
    },
    /** 表格区域页码改变时会触发 */
    tableAreaHandleCurrentChange(uniqueNum, val) {
      this.tableAreaCurrentPage = val;
      this.getTableAreaConfig();
    },
    /** 表格区域每页条数改变时触发 */
    tableAreaHandleSizeChange(uniqueNum, val) {
      this.tableAreaLimit = val;
      this.tableAreaCurrentPage = 1;
      this.getTableAreaConfig();
    },
  },
  mounted() {
    this.getPageMenu();
    this.getQueryAreaConfig();
    this.getTableAreaConfig();
  },
};
</script>

<style lang="scss" scoped>
::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #409eff;
  color: white;
}
.el-divider--horizontal {
  margin: 5px 0;
}
::v-deep .isShowClass {
  .el-switch__label--left {
    position: relative;
    left: 40px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__core {
    width: 65px !important;
  }
  .el-switch__label--right {
    position: relative;
    right: 40px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }
  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
.el-form-item {
  .el-form-item__content {
    .el-select {
      width: 100%;
    }
  }
}
.el-dialog__wrapper {
  .el-dialog {
    margin-top: 1px;
  }
}
</style>
